import Component from './Component';
import Flickity from 'flickity';

// load Flickity carousel if multiple banner items exist.

export default class BannerCarousel extends Component {
  load() {
    this.initFlickity();
    super.load();
  }

  initFlickity() {
    const backgroundContainer = document.querySelector('.banner');
    if (backgroundContainer && backgroundContainer.childElementCount > 1) {
      new Flickity(backgroundContainer, {
        wrapAround: true,
        imagesLoaded: true,
        autoPlay: 5000,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
      });
	  }
  }
}
